var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    width: 20,
    height: 20,
    style: {
      borderColor: "rgba(0,0,0,0)",
      borderWidth: "bpx",
      borderStyle: "undefined"
    },
    filter: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.192 4.032c-0.288-0.16-0.576-0.256-0.864-0.256-1.216-0.032-2.464-0.032-3.68-0.032-0.032 0-0.064 0.032-0.128 0.032v4.672c0 0.608-0.32 0.928-0.928 0.928h-13.024c-0.768 0-1.088-0.288-1.088-1.056v-4.576h-3.68c-1.088 0.032-1.952 0.864-1.952 1.952v24.512c0 0.96 0.768 1.728 1.728 1.76 0.128 0.032 0.256 0.032 0.384 0.032 7.328 0 14.656-0.032 21.984 0 1.088 0 1.856-0.384 2.208-1.44v-25.184c-0.192-0.544-0.416-1.088-0.96-1.344zM23.168 16.192c-2.24 2.24-4.48 4.512-6.752 6.784-0.448 0.448-0.928 0.928-1.376 1.408-0.48 0.48-0.928 0.448-1.408 0-1.568-1.504-3.136-3.008-4.704-4.48-0.544-0.544-0.576-0.992-0.064-1.536 0.32-0.288 0.608-0.608 0.928-0.896 0.48-0.512 0.896-0.512 1.408-0.032l2.976 2.752c0.032 0.032 0.096 0.064 0.128 0.096 1.024-1.024 2.048-2.016 3.040-3.008 1.152-1.12 2.272-2.272 3.424-3.424 0.512-0.544 0.96-0.544 1.472 0 0.32 0.32 0.608 0.608 0.896 0.928 0.48 0.448 0.48 0.928 0.032 1.408zM11.072 7.488c0.288 0.064 0.608 0.032 0.896 0.032 2.848 0.032 5.728 0.032 8.576 0h0.32c0.512-0.096 0.768-0.416 0.8-0.896v-2.88c-0.032-0.928-0.48-1.6-1.216-1.792-0.288-0.064-0.576-0.064-0.864-0.064-0.544-0.032-1.12-0.032-1.664-0.032-0.032-0.16-0.032-0.256-0.064-0.384-0.032-0.736-0.288-1.312-1.088-1.472h-1.536c-1.024 0.224-1.088 1.056-1.12 1.856h-1.792c-1.152 0-1.92 0.736-1.952 1.888-0.032 0.96-0.032 1.952 0 2.912 0 0.448 0.256 0.768 0.704 0.832z",
    fill: "rgba(102,102,102,1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYs);
export default __webpack_public_path__ + "static/media/ys.6fd11689.svg";
export { ForwardRef as ReactComponent };